import React from 'react';

import { IDoc } from '../../../api/investorApi';

import InvestorBlock from '../InvestorBlock';
import ContentList from '../ContentList';
import { OverallPdfCard } from '../PdfCard';

interface IProps {
  title: string;
  anchor: string;
  data: IDoc[];
}
function Calendar(props: IProps) {
  const { title, anchor, data } = props;
  return (
    <InvestorBlock linkOut linkUrl="/investor/calendar" title={title} anchor={anchor} hasMore>
      <ContentList smHideLast>
        {data?.map((doc) => {
          return <OverallPdfCard key={doc.id} title={doc.title} date={doc.date} link={doc.link} />;
        })}
      </ContentList>
    </InvestorBlock>
  );
}

export { Calendar };
